import { useEffect, useState, useContext } from 'react';
import CommonTable from '../common/commonTable/CommonTable';
import CompanyModal from './CompanyModal';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import { companyCrud, exportCompany } from '../../api/company';
import DeleteModal from '../common/commonModal/DeleteModal';
import PaginationComponent from '../common/pagination/Pagination';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import Context from '../../context/Context';

const Company = ({ filters: propFilters, setFilters: propSetFilters, disableTitleUpdate }) => {
    const [companyData, setCompanyData] = useState([]);
    const { setPageTitle } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    const [internalFilters, setInternalFilters] = useState({});
    const filters = propFilters !== undefined ? propFilters : internalFilters;
    const setFilters = propSetFilters !== undefined ? propSetFilters : setInternalFilters;

    const columns = [
        { header: 'Company Name', accessor: 'sheet_company_name' },
        { header: 'Identifier Code', accessor: 'identifier_code' },
    ];

    const [showCompanyModal, setShowCompanyModal] = useState(false);
    const [editingCompany, setEditingCompany] = useState(null);

    const [showDelModal, setShowDelModal] = useState(false);
    const [delRow, setDelRow] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [hasFetched, setHasFetched] = useState(false);

    const itemsPerPage = 10;
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const { searchQuery } = location.state || {};
        if (searchQuery) {
            setFilters({ search: searchQuery });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, setFilters]);

    const handlePageChange = (page) => {
        setSearchParams({ p: page });
        setCurrentPage(page);
    };

    const handleDeleteClick = (row) => {
        setDelRow(row);
        setShowDelModal(true);
    };

    const handleDelete = () => {
        if (delRow?.id) {
            companyCrud(delRow, 'delete', (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllCompanies(currentPage, filters);
                    setShowDelModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleAddClick = () => {
        setEditingCompany(null);
        setShowCompanyModal(true);
    };

    const handleEditClick = (row) => {
        setEditingCompany(row);
        setShowCompanyModal(true);
    };

    const handleModalSaveSuccess = () => {
        const pageToFetch = editingCompany ? currentPage : 1;
        fetchAllCompanies(pageToFetch, filters);
    };

    const fetchAllCompanies = (page, appliedFilters) => {
        setLoading(true);
        const payload = { page, ...appliedFilters };
        companyCrud(payload, 'get', (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setCompanyData(response?.data);
            }
            setLoading(false);
            setHasFetched(true);
        });
    }

    const handleDownload = () => {
        exportCompany({}, () => {
        });
    }

    useEffect(() => {
        if (!disableTitleUpdate) {
            setPageTitle('Companies');
        }
        const pageFromUrl = parseInt(searchParams.get('p')) || 1;
        setCurrentPage(pageFromUrl);
    }, [setPageTitle, searchParams, disableTitleUpdate]);
    
    useEffect(() => {
        fetchAllCompanies(currentPage, filters);
    }, [currentPage, filters]);

    return (
        <section>
            <div className='px-4'>
                <CommonTable
                    columns={columns}
                    data={companyData}
                    actions={['edit', 'delete']}
                    onAdd={handleAddClick}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    addButtonText="Add"
                    loading={loading}
                    hasFetched={hasFetched}
                    isExport={true}
                    handleDownload={handleDownload}
                    sortAble={true}
                    sortedCol={["sheet_company_name"]}
                    idAccessor="id"
                />
                {totalCount > 10 && <PaginationComponent
                    currentPage={currentPage}
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                />}
                <CompanyModal
                    show={showCompanyModal}
                    onHide={() => setShowCompanyModal(false)}
                    initialData={editingCompany}
                    onSaveSuccess={handleModalSaveSuccess}
                />
                <DeleteModal
                    show={showDelModal}
                    onClose={() => setShowDelModal(false)}
                    onConfirm={handleDelete}
                    title="Delete Company"
                    message="Are you sure you want to delete this company? This action cannot be undone."
                />
            </div>
        </section>
    )
}
export default Company;